import Button from "components/base/Button";
import Page from "components/base/Page";
import { ContainerCostForm } from "components/shared/ContainerizationView";
import { useModals } from "ModalProvider";
import { Link, Navigate, Route, Routes } from "react-router-dom";
import HandledPlanList from "./HandledPlanList";
import LumpSumPage from "./lumpSum";
import PlanDetail from "./PlanDetail";
import PlanList from "./PlanList";
import OSStockOverview from "./stockOverview";

const OrderSchedulerRoutes = () => {
  return (
    <Routes>
      <Route path="plans" element={<OrderSchedulerIndexPage />} />
      <Route path="plans/:id" element={<PlanDetail />} />
      <Route path="plans/handled" element={<HandledPlanList />} />
      <Route path="plans/handled/:id" element={<PlanDetail />} />
      <Route path="plans/lumpsum/*" element={<LumpSumPage />} />
      <Route path="plans/stocks/*" element={<OSStockOverview />} />
      <Route path="*" element={<Navigate to="/order-scheduler/plans" />} />
    </Routes>
  );
};

const OrderSchedulerIndexPage = () => {
  const modal = useModals();

  const renderCostUpdate = () => {
    modal.present({
      title: "Shipping Cost Update",
      center: true,
      isBeingPresented: true,
      maxWidth: "max-w-2xl",
      children: <ContainerCostForm hide={modal.hide} />,
    });
  };

  return (
    <Page
      staticHeader
      title="Order Scheduler"
      rightButtons={
        <div className="flex space-x-6">
          <Button onClick={renderCostUpdate}>Shipping Cost Update</Button>
          <Link to="handled">Handled Plans</Link>
          <Link to="lumpsum">Lump Sum</Link>
          <Link to="stocks">Stock Overview</Link>
        </div>
      }
    >
      <PlanList />
    </Page>
  );
};

export default OrderSchedulerRoutes;
